import React, { Component } from 'react';
import { contains } from 'ramda';
import { object, func } from 'prop-types';
import Paper from 'material-ui/Paper';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from "material-ui/styles/getMuiTheme";

// Redux
import { connect } from 'react-redux';
import { fetchFirstBlockNotifications, fetchSecondBlockNotifications } from '../../../../actions/notifications/notificationActions';
import { getLinks, getUrlForAssociatedLink } from '../../../../actions/links/linkActions';
import { setMetadata } from '../../../../actions/metadata/metadataActions';
import { setHeaderTitle } from '../../../../actions/header/headerActions';
import { ACCOUNT_PREFERENCES } from '../../../../actions/preferences/types';
import { FETCH_FIRST_BLOCK_NOTIFICATIONS, FETCH_SECOND_BLOCK_NOTIFICATIONS } from '../../../../actions/notifications/types';
import { GET_LINKS } from '../../../../actions/links/types';

// Page layout
import PracticeLocation from '../PracticeLocation';
import PracticeMap from '../../../PracticeMap';
import Notifications from '../../../Notifications';
import Links from '../../../Links';

import s from './LandingPage.css';

import portalTheme from "../../../../themes/portalTheme";

export class LandingPage extends Component {
  static propTypes = {
    account: object,
    fetchFirstBlockNotifications: func,
    fetchSecondBlockNotifications: func,
    getLinks: func,
    getUrlForAssociatedLink: func,
    header: object,
    links: object,
    loading: object,
    metadata: object,
    notifications: object,
    setHeaderTitle: func,
    setMetadata: func,
  };

  componentWillMount() {
    this.props.setMetadata({
      activeMenuItemKey: 'home',
      pageTitle: 'Home',
      pageDescription: 'Your dashboard',
    });

    this.props.setHeaderTitle('Home');

    this.props.fetchFirstBlockNotifications();
    this.props.fetchSecondBlockNotifications();
    this.props.getLinks();
  };

  render = () => {
    const { location } = this.props.account;
    const { appointmentSchedulingEnabled, appointmentViewingEnabled, appointmentWaitlistingEnabled } = this.props.authenticatedPreferences;
    const appointmentSchedulingViewingOrWaitlisting = appointmentSchedulingEnabled || appointmentViewingEnabled || appointmentWaitlistingEnabled;

    const renderPracticeMap = () => {
      if (location) {
        return (
          <div className={s.heightContainer}>
            <MuiThemeProvider muiTheme={getMuiTheme(portalTheme)}>
              <Paper style={{ position: 'relative', height: '100%', width: '100%' }}>
                <PracticeMap
                  address={`${location.address1} ${location.city} ${location.state} ${location.fullCountryName} ${location.postalCode}`}
                />
              </Paper>
            </MuiThemeProvider>
          </div>
        );
      }
    };

    return (
      <section className={s.component}>
        <div className={s.flexContainer}>
          <div className={s.box}>
            <PracticeLocation
              isLoading={contains(ACCOUNT_PREFERENCES, this.props.loading.requests)}
              location={location}
            />
          </div>
          <section className={s.box}>
            {renderPracticeMap()}
          </section>
        </div>
        <div className={s.flexContainer}>
          <div className={s.box}>
            <Notifications
              isLoading={contains(FETCH_FIRST_BLOCK_NOTIFICATIONS, this.props.loading.requests)}
              data={this.props.notifications.firstBlock.notifications}
              header={this.props.notifications.firstBlock.header}
            />
          </div>
          <div className={s.box}>
            {appointmentSchedulingViewingOrWaitlisting &&
              <Notifications
                isLoading={contains(FETCH_SECOND_BLOCK_NOTIFICATIONS, this.props.loading.requests)}
                data={this.props.notifications.secondBlock.notifications}
                header={this.props.notifications.secondBlock.header}
              />
            }
          </div>
        </div>
        <div className={s.flexContainer}>
          <div className={s.box}>
            <Links
                isLoading={contains(GET_LINKS, this.props.loading.requests)}
                data={this.props.links}
                action={this.props.getUrlForAssociatedLink}
            />
          </div>
          <div className={s.box}/>
        </div>
      </section>
    );
  }
}

const mapStateToProps = state => ({
  account: state.account,  // @TODO: this is going to need to display an error ui
  authenticatedPreferences: state.authenticatedPreferences,
  header: state.header,
  loading: state.loadingState,
  metadata: state.metadata,
  notifications: state.notifications,
  links: state.links,
});

const mapDispatchToProps = dispatch => ({
  setHeaderTitle: title => dispatch(setHeaderTitle(title)),
  setMetadata: metadata => dispatch(setMetadata(metadata)),
  fetchFirstBlockNotifications: () => dispatch(fetchFirstBlockNotifications()),
  fetchSecondBlockNotifications: () => dispatch(fetchSecondBlockNotifications()),
  getLinks: () => dispatch(getLinks()),
  getUrlForAssociatedLink: (callee) => dispatch(getUrlForAssociatedLink(callee))
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);



// WEBPACK FOOTER //
// ./src/components/Pages/Home/LandingPage/LandingPage.js